export class GetCommands {
    constructor(
      commands,
    ) {
        this.commands = commands;
    }
    static createFromResponseData(data) {
        let commands = data.map((command) => {
          return command;
        });
        return new GetCommands(
          commands,
        );
    }
  };